// global modules
import { mapActions } from "vuex"
import { ModelDataTable } from "@/components/reusable_components/next"

// local modules
import PurchaseInvoiceService from "@/services/api/Purchase/PchPurchaseInvoice"

// local objects
import filters from "./filters"
import headers from "./headers"

/**
 * @description
 * 
 */
export default {
    name: "purchase-invoice-list",
    components: {
        ModelDataTable,
    },
    computed: {

        /**
         * @description
         * 
         */
        tableProps () {
            return {
                ...this.tableParams,
                service: new PurchaseInvoiceService().toList(),
                filters,
                headers,
                rowsPerPage: 25,
            }
        },
    },
    methods: {
        
        /**
         * @description
         * 
         */
        ...mapActions("MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
        }),

        /**
         * @description
         * 
         */
        submitDetail ( event ) {
            this.$router.push({ name: "purchase-invoice-update", params: { id: event.item.id } })
        },
    },
    props: {

        /**
         * 
         */
        noItems: Boolean,

        /**
         * 
         */
        tableParams: {
            type: Object,
            default: () => ({}),
        },
    },
    beforeMount () {

        // set the view title
        this.setTitleTopBar( "Facturas de compra" )
    },
    beforeRouteEnter ( to, from, next ) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PURCHASE_INVOICE')) ctx.$router.push('/')
        })
    },
}
